function RightArrowIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="16"
      fill="none"
      viewBox="0 0 6 12"
    >
      <path
        fill="#F3953F"
        d="M5.355 5.341L1.243 1.144C.76.65 0 1.052 0 1.804v8.392c0 .168.041.333.12.475.077.141.189.253.32.323s.277.093.42.069a.708.708 0 00.384-.208l4.11-4.196a.878.878 0 00.19-.297 1 1 0 000-.724.878.878 0 00-.19-.297h.001z"
      ></path>
    </svg>
  );
}

export default RightArrowIcon;
